<template>
  <base-layout>
    <v-row class="justify-space-between">
      <v-col class="row" md="8" cols="8">
        <v-col md="9" cols="8">
          <v-text-field v-model="searchText" dense label="Search" @keydown.enter="searchItem"/>
        </v-col>
        <v-col md="3" class="d-flex justify-end" cols="4">
          <v-btn outlined small color="primary" @click="searchItem()">
            Find
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <paginate
      :page="parseInt(page)"
      :per-page="perPage"
      :total="total"
      @on-page-change="changePage" />
    <v-data-table
      :headers="headers"
      :items-per-page="15"
      :items="mapedData"
      :loading="loading"
      disable-sort
      hide-default-footer
      class="elevation-1" />
  </base-layout>
</template>

<script>
import AccessLogProvider from '@/resources/AccessLogProvider'
import { mapActions } from 'vuex'

const dayjs = require('dayjs')
const accessService = new AccessLogProvider()
export default {
  data: () => ({
    searchText: '',
    loading: false,
    perPage: 15,
    total: 15,
    page: 1,
    data: [],
    headers: [
      { text: 'IP', align: 'start', value: 'ip' },
      { text: 'Activity', value: 'note' },
      { text: 'E-mail', value: 'email' },
      { text: 'Date', value: 'createdAt' }
    ]
  }),
  computed: {
    mapedData () {
      return this.data.map(d => ({
        id: d.id,
        ip: d.ip,
        note: d.note,
        createdAt: dayjs(d.createdAt).format('DD-MM-YYYY HH:mm'),
        email: d.user.email
      }))
    }
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar'
    }),
    changePage (page) {
      this.page = page
      this.getData()
    },
    searchItem () {
      this.page = 1
      this.getData()
    },
    async getData () {
      this.loading = true
      try {
        const query = `page=${this.page}&limit=${this.perPage}&search=${this.searchText}`
        const { data } = await accessService.getAccessLog(query)
        this.total = data.total
        this.data = data.results
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.getData()
  }
}
</script>
